<template lang="html">
  <v-dialog 
    v-model="dialog" 
    persistent
    max-width="450"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="$hasPermissionTo(['create kpi target feedback'])"
        color="primary"
        dark
        v-on="on"
      >
        Target Feedback
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      :title="user.name"
      color="green"
      text="Add Target Feedback"
      class="mb-0"
    >
      <v-form
        ref="form"
        v-model="formValid"
      >
        <v-col>
          <v-autocomplete
            v-model="selectedKpiType"
            :items="kpiTypes"
            :rules="rules"
            class="mx-2"
            hide-no-data
            hint
            hide-selected
            label="KPI Types"
            placeholder="Select KPI Type"
            item-text="name"
            item-value="id"
            filled
            background-color="white"
          />
        </v-col>

        <v-col>
          <v-text-field
            v-model="feedback"
            :rules="rules"
            class="mx-2"
            type="number"
            label="Target Feedback Amount *"
          />
        </v-col>

        <v-col>
          <v-textarea
            v-model="remark"
            :rules="rules"
            label="Remark *"
            counter="90"
            outlined
            rows="2"
          />
        </v-col>

        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="progressing"
            text
            @click="setDialog(false)"
          >
            Close
          </v-btn>
          <v-btn
            :loading="progressing"
            color="success"
            @click="submitForm"
          >
            Feedback
          </v-btn>
        </v-card-actions>
      </v-form>
    </material-card>
  </v-dialog>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        dialog: false,
        progressing: false,
        feedback: null,
        rules: [
          value => !!value || 'Required.',
        ],
        formValid: true,
        kpiTypes: [],
        selectedKpiType: null,
        remark: '',
      }
    },
    computed: {
      ...mapState({ user: 'currentUser', employee: 'currentEmployee' }),
    },
    watch: {
      dialog: function (status) {
        if (status && !this.isDataLoaded()) {
          this.init()
        }
      },
    },
    methods: {    
      init () {
        this.$api.kpiCategories().list()
          .then((kpiTypes) => {
            this.kpiTypes = kpiTypes.data
          })

        this.$refs.form.reset()
      },
      isDataLoaded () {
        return this.kpiTypes.length > 0
      },
      submitForm () {
        if (this.$refs.form.validate()) {
          this.setProgressing(true)
        
          this.$http.post('/api/employees/' + this.employee.employee_uid + '/kpi-target-feedback', this.prepareFormData())
            .then((res) => {
              if (res.status === 201) {
                this.$refs.form.reset()

                this.setDialog(false)
                this.$snack({
                  message: 'Feedback updated successfully!',
                })
                this.feedbackSaved()
              }
            })
            .catch(() => {})
            .then(() => {
              this.setProgressing(false)
            })
        }
      },
      feedbackSaved () {
        this.$emit('feedback-saved')
      },
      setProgressing (value = false) {
        this.progressing = value
      },
      setDialog (status) {
        this.dialog = status
      },
      prepareFormData () {
        let data = {
          value: parseInt(this.feedback),
          kpi_category_id: this.selectedKpiType,
          remark: this.remark,
        }
      
        return data
      },
    },

  }
</script>
